module.exports = vendor_7775776852df7e1deb90;